import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';

const mapSolutionToDraftLineItem = ({ sku , quantity , state  })=>{
    const lineItemDraft = {
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        type: 'regular'
    };
    if (isSubscriptionPurchase(state.configurations.purchaseType)) {
        if (!state.configurations.subscriptionPurchaseConfigurations.deliveryInterval) {
            return;
        }
        lineItemDraft.typeDetails = {
            isSubscription: true,
            subscriptionDetails: {
                deliveryInterval: state.configurations.subscriptionPurchaseConfigurations.deliveryInterval
            }
        };
    }
    return lineItemDraft;
};

export { mapSolutionToDraftLineItem };
//# sourceMappingURL=map-solution-to-draft-line-item.js.map
